import axios from "axios";

const SMARTMOVING_BASE_URL = "https://api-public.smartmoving.com/v1/api/";

export const smartMovingApiCall = async ({
  url,
  method,
  data,
  params,
  headers = {},
  contentType,
}: any) => {

  const defaultHeaders: Record<string, string> = {
    "x-api-key": "42640417de144fc98ab233db1e67d018",
  };
  if (contentType) {
    defaultHeaders["Content-Type"] = contentType;
  } else if (data && !(data instanceof FormData)) {
    defaultHeaders["Content-Type"] = "application/json";
  }
  const combinedHeaders = { ...defaultHeaders, ...headers };

  const api = axios.create({
    baseURL: SMARTMOVING_BASE_URL,
    headers: combinedHeaders,
  });

  const response = await api.request({
    url,
    method,
    data,
    params,
  });

  return response.data;
};
